import React from "react";
import DateHelper from "../../DateHelper/DateHelper";
import { differenceInCalendarDays } from "date-fns";
import I18n from "i18n-js";

export default class BookingSummarySection extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeStep = this.onChangeStep.bind(this);
  }

  render() {
    var self = this;
    var reservation_segments = this.props.reservation_segments.map(
      (reservation_segment, idx) => {
        var total_guest_count = self.getTotalGuestCount(reservation_segment);
        var duration = differenceInCalendarDays(
          new Date(reservation_segment.check_out_date),
          new Date(reservation_segment.check_in_date)
        );

        return (
          <div
            className={idx === 0 ? "top-segment" : "segment-summary"}
            key={reservation_segment.id}
            style={{ lineHeight: "1.5em" }}
          >
            <strong>{reservation_segment.room_type.name}</strong>:&nbsp;
            {DateHelper.printDateToScreen(
              new Date(reservation_segment.check_in_date),
              self.props.date_format
            )}{" "}
            -{" "}
            {DateHelper.printDateToScreen(
              new Date(reservation_segment.check_out_date),
              self.props.date_format
            )}
            &nbsp; (
            {duration == 1
              ? I18n.t("num_night", { num: duration })
              : I18n.t("num_nights", { num: duration })}
            ,&nbsp;
            {total_guest_count}{" "}
            {total_guest_count == 1
              ? I18n.t("guest").toLowerCase()
              : I18n.t("guests").toLowerCase()}
            )
            <a
              href="#"
              className="remove-segment"
              onClick={self.props.onRemoveReservationSegment.bind(
                this,
                reservation_segment.id
              )}
            >
              <span className="ss-trash"></span>
            </a>
          </div>
        );
      }
    );

    return (
      <div className="SummarySection">
        <div className="panel panel-default">
          <div className="panel-body not-expandable">
            <div className="expand-collapse-header">
              <h3 className="summary-section-header">
                {reservation_segments && reservation_segments.length == 1
                  ? I18n.t("selected_room")
                  : I18n.t("selected_rooms")}
              </h3>
              {reservation_segments}
              <div className="add-another-room">
                <a href="#" onClick={this.onChangeStep}>
                  {I18n.t("add_another_room")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Change handlers
   */

  onChangeStep(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.onChangeStep("accommodations");
  }

  /**
   * Helper functions
   */

  getTotalGuestCount(reservation_segment) {
    var count = 0;

    for (
      var i = 0,
        ilen = reservation_segment.reservation_segment_guest_types.length;
      i < ilen;
      i++
    ) {
      count =
        count +
        reservation_segment.reservation_segment_guest_types[i].number_of_guests;
    }

    return count;
  }
}
